<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-3 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  Página Web para su notaría
                  <span>Solución Integral</span>
                </h1>
                <p class="lead  text-white">
                  Aprezca en internet y muestre su notaría a los potenciales clientes.
                </p>
                <div class="btn-wrapper">
                  <!-- <p class="lead text-white">
                    This web app can be generated in Vue.js combined with
                    Express / Flask or Laravel. Your choice :)
                  </p> -->
                  <a
                    target="_blank"
                    href="#"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                    v-scroll-to="'#contacto'"
                  >
                    <i style="color: red" class="fa fa-rocket"></i>
                    <span class="btn-inner--text"
                      >Solicitar Demo</span
                    >
                  </a>
                  <a
                    target="_blank"
                    href="https://notariademo.notin.es"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                  >
                    <i style="color: red" class="fa fa-globe"></i>
                    <span class="btn-inner--text"
                      >Ver Demo</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
  <div class="profile-page">
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img
                      v-lazy="'img/sq_nmp.png'"
                      class="rounded-circle rounded-notin bg-white"
                    />
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
              
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
            
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-lg-12 text-center mt-5"><br><br><br>
                    <h3>
                      Página Web
                    </h3>
                  
                </div>
            </div>
            <div class="mt-2 py-2 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <p>
                    Con un diseño y funcionalidades hechas para las notarías, acérquese a sus clientes potenciales mediante una página web.<br>
                    Actualmente estar presente en internet es símbolo de modernidad y cercanía hacía la ciudadanía.<br>
                    Aprovechamos nuestra experiencia y conocimiento del sector para facilitar la creación de la página web.<br>
                  </p>
                  <!-- <a href="#">Show more</a> -->
                </div>
                <div class="row">
                    <div class="col-lg-12 mb-4 px-5">
                      <h3>Apartados</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4 px-5">
                      <ul class="list-unstyled mt-2">
                          
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-blue text-white"
                              icon="fa fa-home"
                              ></badge>
                              <h6 class="mb-0">Home</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-purple text-white"
                              icon="fa fa-user-tie "
                              ></badge>
                              <h6 class="mb-0">Notarios</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-indigo text-white"
                              icon="fa fa-users "
                              ></badge>
                              <h6 class="mb-0">Equipo</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-folder-open"
                              ></badge>
                              <h6 class="mb-0">Servicios</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-picture-o"
                              ></badge>
                              <h6 class="mb-0">Galería</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-green text-white"
                              icon="fa fa-bookmark"
                              ></badge>
                              <h6 class="mb-0">Blog</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-red text-white"
                              icon="fa fa-address-book"
                              ></badge>
                              <h6 class="mb-0">Formulario de contacto</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-grey text-white"
                              icon="fa fa-chart-pie"
                              ></badge>
                              <h6 class="mb-0">Analíticas</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-pink text-white"
                              icon="fa fa-columns"
                              ></badge>
                              <h6 class="mb-0">Panel de Control</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-plus "
                              ></badge>
                              <h6 class="mb-0">Y mucho más... </h6>
                          </div>
                          </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <a href="https://notariademo.notin.es">
                        <img class="w100 pt-2 pl-2 pr-2" v-lazy="'img/Home-Web.png'"/>
                        <h4>Portada Página Web</h4>
                      </a>
                    </div>
                    <!-- <a href="#">Show more</a> -->
                  </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
    <section class="section section-lg pt-lg-0 ">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
              <h2 class="display-3 text-center">Todo lo necesario de una web</h2>
            <div class="row row-grid mt-5">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-check-bold"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Diseño</h6>
                  <p class="description mt-3">
                    Diseñado para notarías. Con el objetivo de mostrar toda aquella información importante de una forma limpia y sencilla para la correcta comprensión por parte del cliente.
                  </p>
                  <div>
                    <badge type="primary" rounded>amigable</badge>
                    <badge type="primary" rounded>sencillo</badge>
                    <badge type="primary" rounded>dinámico</badge>
                  </div>
                  <base-button tag="a" href="https://notariademo.notin.es" type="primary" class="mt-4">
                    Página Demo
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-cloud-upload-96"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Contenido</h6>
                  <p class="description mt-3">
                    Todo el contenido posible puede ser creado y administrado por la notaría. Cuéntales a tus clientes como es tu notaría, tus servicios, tus artículos y todo lo que necesites mediante la página web. 
                  </p>
                  <div>
                    <badge type="success" rounded>servicios</badge>
                    <badge type="success" rounded>blop</badge>
                    <badge type="success" rounded>atención</badge>
                  </div>
                  <base-button tag="a" href="https://controlpanel.notin.es" type="success" class="mt-4">
                    Panel de Control
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-paper-diploma" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Customizable</h6>
                  <p class="description mt-3">
                    Podrás customizar hasta el último detalle de la página web. Podrás seleccionar qué apartados mostrar, con qué información y con qué fotos.
                  </p>
                  <div>
                    <badge type="warning" rounded>custom</badge>
                    <badge type="warning" rounded>colores</badge>
                    <badge type="warning" rounded>imágenes</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="warning" class="mt-4">
                    Demostración
                  </base-button>
                </card>
              </div>
            </div>
            <div class="row row-grid mt-5">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-check-bold"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Panel de Control</h6>
                  <p class="description mt-3">
                    Mediante el panel de control, tendrás la autonomía necesaria para cambiar cualquier aspecto de la página web. Podrás modificar cualquier cosa a tu gusto.
                  </p>
                  <div>
                    <badge type="primary" rounded>panel de control</badge>
                    <badge type="primary" rounded>diseño</badge>
                    <badge type="primary" rounded>autonomía</badge>
                  </div>
                  <base-button tag="a" href="https://controlpanel.notin.es" type="primary" class="mt-4">
                    Panel de Control
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-cloud-upload-96"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Continuo Desarrollo</h6>
                  <p class="description mt-3">
                    Siguiendo con la filosofía Notin, cualquier mejora o avance que se requiera sobre la página web, será desarrollada para la continua evolución en nuestros productos.
                  </p>
                  <div>
                    <badge type="success" rounded>continuo</badge>
                    <badge type="success" rounded>desarrollo</badge>
                    <badge type="success" rounded>mejora</badge>
                  </div>
                  <base-button tag="a" href="https://notariademo.notin.es" type="success" class="mt-4">
                    Página Demo
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-paper-diploma" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Velocidad</h6>
                  <p class="description mt-3">
                    Gracias a nuestros desarrollos con las últimas tecnologías del mercado, tu página web será la más potente del mercado, cargando el contenido en apenas unos segundos.
                  </p>
                  <div>
                    <badge type="warning" rounded>velocidad</badge>
                    <badge type="warning" rounded>herramientas</badge>
                    <badge type="warning" rounded>potencia</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="warning" class="mt-4">
                    Demostración
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12 mt-5">
              <card class=" bg-gradient-success border-0" shadow body-classes="py-5">
                <h4 class="text-center"><b>Valores de adaptación</b></h4>
              <h5 class=" text-center">
                 Detrás del producto hay un equipo que valora las peticiones de los usuarios y trata constantemente de adaptar el producto a las peculiaridades del entorno y a la mejora continua de los procesos para avanzar en eficacia y productividad. Una petición de cambio no es un problema sino una puesta en valor del uso razonado de nuestra herramienta.
              </h5>
              </card>
          </div>
        </div>
      </div>
    </section>
    

   
  </div>
</template>

<script>

export default {
  name: "pagina-web",
};
</script>
<style scoped>

</style>